import { Slot, component$ } from "@builder.io/qwik";
import { NavLink, type NavLinkProps } from "./nav-link";
import { cn } from "~/lib/cn";
import { LuCheck } from "@qwikest/icons/lucide";

export const TabList = component$<{ class?: string }>((props) => {
  return (
    <nav
      class={cn(
        "text-muted-foreground border-b-1 inline-flex h-10 items-center justify-start gap-2 border-b-gray-200",
        props.class,
      )}
    >
      <Slot />
    </nav>
  );
});

type TabProps = NavLinkProps & {
  href?: string;
  "data-state"?: string;
  completed?: boolean;
};

export const Tab = component$<TabProps>((props) => {
  return (
    <NavLink
      class={[
        "ring-offset-background focus-visible:ring-ring border-b-1 hover:border-b-brand-600 hover:text-brand-600 data-[state=selected]:border-b-brand-700 data-[state=selected]:text-brand-700 -mb-2 inline-flex items-center justify-center whitespace-nowrap border-b-transparent px-4 py-1.5 text-sm font-medium transition-all focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50",
        "relative gap-2",
      ]}
      {...props}
    >
      <Slot />
      {props.completed != undefined && (
        <div
          class={[
            "flex h-4 w-4 items-center justify-center rounded-full text-xs text-white",
            props.completed ? "bg-lime-500" : "bg-gray-200",
          ]}
        >
          {props.completed && <LuCheck />}
        </div>
      )}
    </NavLink>
  );
});

export const TabContent = component$(() => {
  return (
    <div class="ring-offset-background focus-visible:ring-ring mt-2 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2">
      <Slot />
    </div>
  );
});
